import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22gtWalsheim.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./GTWalsheim-Light.otf%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22./GTWalsheim-Regular.otf%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./GTWalsheim-Medium.otf%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22./GTWalsheim-Bold.otf%22,%22weight%22:%22700%22,%22style%22:%22normal%22}],%22variable%22:%22--font-clarityos-homepage%22,%22display%22:%22swap%22}],%22variableName%22:%22gtWalsheim%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'gtWalsheim', 'gtWalsheim Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
